<template>
  <div
    :class="{
      'fi-grid': true,
      [getColumns]: true,
      [gridBaseClass]: true,
      [gridClass]: gridClass,
      'grid-columns-fi--container': container,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'GridColumnsFi',
  props: {
    columns: {
      type: Number,
      default: 12,
    },
    gridClass: {
      type: String,
      default: null,
    },
    gridBaseClass: {
      type: String,
      default: 'fi-gap-small md:fi-gap-large',
    },
    container: Boolean,
  },
  computed: {
    getColumns() {
      return `fi-grid-cols-${this.columns}`;
    },
  },
};
</script>

<style scoped src="./grid-columns-fi" />
